import React, { useCallback, useContext, useEffect, useState } from "react";

// css
import { Converter } from "showdown";
import "survey-core/defaultV2.min.css";
import { StylesManager } from "survey-core";
import { Model, Serializer, Survey } from "survey-react";
import "./Survey_Screen.css";

// import context
import { LanguageContext } from "../../context/languageContext";
import {
  componentsNamesFactoryForTitle,
  questionFactory,
} from "../../Helper_functions/Languages/LanguageSelector";
import { getCachedSurvey } from "../../Helper_functions/databaseService/databaseService";
import { LanguageIdContext } from "../../context/languageIdContext";
import { Button } from "reactstrap";

StylesManager.applyTheme("defaultV2");

Serializer.addProperty("question", "popupdescription:text");
Serializer.addProperty("page", "popupdescription:text");

interface Survey_Screen_Int {
  set_data: (data: any) => void;
  setSurveyDone: React.Dispatch<React.SetStateAction<boolean>>;
  returnSurveyModel: (survey:Model) => void;
}

//tsx component
function Survey_Screen({ set_data, setSurveyDone,returnSurveyModel }: Survey_Screen_Int) {
  const { languageId } = useContext(LanguageIdContext);
  

  const survey = new Model(questionFactory(languageId));
  useEffect(() => {
    returnSurveyModel(survey);
  }, [languageId]);
  const [pageNo, setPageNo] = useState(loadPageNumber());
  
  const moreInfoTitle = componentsNamesFactoryForTitle(languageId, "More Info");
  const perviousTitle = componentsNamesFactoryForTitle(languageId, "Previous");
  const nextTitle = componentsNamesFactoryForTitle(languageId, "Next");
  const completeTitle = componentsNamesFactoryForTitle(languageId, "Complete");
  survey.onValidateQuestion.add(validateDomain);
// Check if there are no visible questions or pages

survey.onValueChanged.add(function (sender: any, options: any) {
  saveSurveyData(sender);
})


  const prevPage = () => {
    if(pageNo === 0) return;
    
    survey.prevPage();
    setPageNo(pageNo - 1 );
    savePageNumber(pageNo - 1);

  };
  const nextPage = () => {

    if(survey.isCurrentPageHasErrors){
      return;
    }

    survey.nextPage();

    setPageNo(pageNo +1);
    savePageNumber(pageNo + 1);

  };
  const endSurvey = () => {
    survey.completeLastPage();
  };
  const alertResults = useCallback((sender: any) => {
    set_data(sender.data);
    setSurveyDone(true);
  }, []);

  survey.onComplete.add(alertResults);
  survey.sendResultOnPageNext = true;
  survey.onAfterRenderQuestion.add(function (survey: any, options: any) {
    //Do nothing if a question contains no description to show in a modal popup
    if (!options.question.popupdescription) return;
    //Create a 'More Info' button to invoke a modal popup
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dialog-button";
    btn.innerHTML = moreInfoTitle;
    var question = options.question;
    btn.onclick = function () {
      showDescription(question);
    };
    //Insert the created 'More Info' button into the rendered question's header
    var header = options.htmlElement.querySelector("feildset");
    // console.log(JSON.stringify(survey))
    if (!header) header = options.htmlElement;
    header.appendChild(btn);
  });

  survey.onAfterRenderPage.add(function (survey: any, options: any) {
    //Do nothing if a page contains no description to show in a modal popup
    if (!options.page.popupdescription) return;
    //Create a 'More Info' button to invoke a modal popup
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "dialog-button";
    btn.innerHTML = "More Info";
    btn.onclick = function () {
      showDescription(survey.currentPage);
    };
    var header = options.htmlElement.querySelector("feildset");
    if (!header || !!header.querySelector(".dialogBox-btn")) return;
    header.appendChild(btn);
  });

  const converter = new Converter();
  survey.onTextMarkdown.add(function (survey: any, options: any) {
    // Convert Markdown to HTML
    let str = converter.makeHtml(options.text);
    // Remove root paragraphs <p></p>
    str = str.substring(3);
    str = str.substring(0, str.length - 4);
    // Set HTML markup to render
    options.html = str;
  });

  const storageItemKey = "my-survey";

  function saveSurveyData(survey: any) {
    const data = survey.data;
    data.pageNo = survey.currentPageNo;
    window.localStorage.setItem(storageItemKey, JSON.stringify(data));
  }

  // Save survey results
  survey.onPartialSend.add((survey: any) => {
    saveSurveyData(survey);
  });
  survey.onComplete.add((survey: any) => {
    saveSurveyData(survey);
  });
  
  // Restore survey results
  const prevData = window.localStorage.getItem(storageItemKey) || null;
  if (prevData) {
    const data = JSON.parse(prevData);
    survey.data = data;
    if (data.pageNo) {
      survey.currentPageNo = data.pageNo;
    }
  }
  if (survey.getAllQuestions().length === 0) {
    return (
      <div className="no-questions">
        <p className="no-questions-p">Thank you for using the Mat Facilitator Please press this button to begin the Survey</p>
        <Button color={"primary"} onClick={() => window.location.reload()} size="lg">
          {"Begin"}
        </Button>
      </div>
    );
  }
  return (
    <div className="container">
      <Survey model={survey} currentPageNo ={pageNo}/>
      <div className="button-core-group">
        <button className="button-survey-custom" onClick={prevPage}>
          {perviousTitle}
        </button>
        { pageNo !==survey.visiblePageCount - 1 ? (
          <button className="button-survey-custom" onClick={nextPage}>
            {nextTitle}
          </button>
        ) : (
          <button className="button-survey-complete" onClick={endSurvey}>{completeTitle}</button>
        )}
      </div>
    </div>
  );
}
function showDescription(element: any) {
  let docElement = document.getElementById("questionDescriptionText");
  if (docElement != null) {
    docElement.innerHTML = element.popupdescription;
  } else {
    alert(JSON.stringify(element.popupdescription));
  }
  var popupEl: any = document.getElementById("questionDescriptionPopup");
  let docElement2 = document.getElementById("questionDescriptionPopupClose");
  if (docElement2 != null) {
    docElement2.onclick = () => {
      popupEl.close();
    };
  } else {
    alert(JSON.stringify(element));
  }

  popupEl.showModal();
}

export default Survey_Screen;

// internal components
function validateDomain(_:any, options:any) {
  if (options.name === "email") {
    const email = options.value;

    if (!email)
      return;

    const domain = email.trim().substring(email.indexOf("@") + 1);
    if (domain !== "surveyjs.io") {
      options.error = "Please enter an e-mail address hosted at surveyjs.io.";
    }
  }
}

function savePageNumber(pageNo: number) {
  window.localStorage.setItem("pageNo", JSON.stringify(pageNo));
}
function loadPageNumber() {
  const pageNo = window.localStorage.getItem("pageNo");
  if (pageNo) {
    return JSON.parse(pageNo);
  } else {
    return 0;
  }
}
export function clearPageNumber() {
  window.localStorage.removeItem("pageNo");
}
